import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { getApiDefinitions } from '../../services/api-repositories/api-definitions-repository';
import { initialApiState } from './types';
import { t } from 'i18next';

export const fetchApiPortalData = createAsyncThunk('api/fetchApiDefinitions', async () => {
  return await getApiDefinitions();
});

const apiSlice = createSlice({
  name: 'apiDefinitions',
  initialState: initialApiState,
  reducers: {
    clearApiError: (state) => {
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchApiPortalData.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchApiPortalData.fulfilled, (state, action) => {
        state.loading = false;
        state.apiDefinitions = action.payload;
      })
      .addCase(fetchApiPortalData.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || t('errors.failedToFetchApiData');
      });
  },
});

export const { clearApiError } = apiSlice.actions;
export default apiSlice.reducer;
